import React from 'react';

import { StackProps, TooltipProps } from '@lyearn/ui';
import { BaseButtonProps } from '@lyearn/ui';
import { LinearProgressProps, TypographyType as TypographyProps } from '@lyearn/ui';
import { StatusPillProps } from '@lyearn/ui/dist/esm/Pill/StatusPill/types';
import { ImageProps } from '@/components/Image';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';
import {
  BookmarkType,
  Maybe,
  MicroLearningSubTypeEnum,
  PublicAccessConfigType,
  ResourceTypeEnum,
} from '@/types/schema';

import { OptionsProps } from './Options';

export interface BaseCardContent {
  contentId?: string;
  isOptionalContent?: boolean;
  contentType?: ResourceTypeEnum;
  description?: Maybe<string>;
  image?: Maybe<string>;
  label?: Maybe<string | JSX.Element>;
  labelNode?: Maybe<JSX.Element>;
  type?: Maybe<string>;
  link?: Maybe<string>;
  name?: Maybe<string>;
  cardType?: Maybe<ContentCardTypeEnum>;
  progress?: number;
  status?: {
    label: Maybe<string>;
    appearance?: StatusPillProps['appearance'];
  };
  duration?: string;
  disabled?: boolean;
  date?: Maybe<string>;
  bookmark?: Maybe<Pick<BookmarkType, 'id'>>;
  onBookmarkUpdate?: (id: string | undefined) => void;
  options?: {
    path?: Maybe<string>;
  };
  microLearningSubType?: Maybe<MicroLearningSubTypeEnum | null>;
  publicAccessConfig?: Maybe<PublicAccessConfigType>;
}

export enum BaseCardImageTransitionType {
  GroupHover = 'GROUP_HOVER',
  Hover = 'HOVER',
}

export interface BaseCardImageProps extends ImageProps {
  transitionType?: BaseCardImageTransitionType;
  containerStyle?: any;
  containerClassName?: string;
}

export interface BookmarkProps {
  className?: string;
  classes?: {
    icon?: {
      root?: string;
      bookmarked?: string;
      notBookmarked?: string;
    };
  };
  tooltipProps?: Partial<TooltipProps>;
  appearance?: 'primary' | 'inverse';
}

export interface BaseCardComposition {
  Description: React.FC<
    Partial<TypographyProps> & { containerClassName?: string; truncateLength?: number }
  >;
  Image: React.FC<React.PropsWithChildren<BaseCardImageProps>>;
  Label: React.FC<Partial<TypographyProps>>;
  Link: React.FC<StackProps>;
  Name: React.FC<Partial<TypographyProps>>;
  Options: React.FC<OptionsProps>;
  PrimaryAction: React.FC<
    Omit<BaseButtonProps, 'onClick'> & { onClick?: BaseButtonProps['onClick'] }
  >;
  Bookmark: React.FC<BookmarkProps>;
  Progress: React.FC<Pick<LinearProgressProps, 'className' | 'color'>>;
  Status: React.FC<
    StatusPillProps & {
      iconHeight?: number;
      iconWidth?: number;
      className?: string;
      iconFill?: string;
    }
  >;
}
